// Fixed English copy of the GPU server Budget tab. Provider-free by rule (no file under
// src/app/Datacenter/GpuServers may name the upstream provider), and honest by rule: a budget is an
// estimate — it never reserves capacity, never locks a price, is not a quote, and storage cannot be
// ordered. Never suggest that a server can be paused or run only during working hours.

/** Always visible on the tab, under the totals. */
export const BUDGET_ESTIMATE_NOTE =
  "This is an estimate. GPU servers are paid per started hour from your prepaid balance until they are deleted — a server that is shut down still bills, and it cannot be paused. Prices can change; the price shown when you start a server applies. VAT is indicative; your invoices apply your organisation's VAT regime.";

/** The Budget tab stays fully usable under impersonation (a budget moves no money). */
export const BUDGET_IMPERSONATION_NOTICE =
  "You are editing this organisation's budgets as support. Changes are saved for the organisation.";

/** Under the hours-per-month field. */
export const BUDGET_HOURS_HELP =
  'Hours the server exists in the month. 730 h is an average month (720 h for 30 days, 744 h for 31 days). Fewer hours means the server exists only part of the month: it must be deleted (its data is erased) and started again — a server cannot be paused.';

/** A section whose catalog kind is not orderable and whose registry entry has no note of its own. */
export const BUDGET_GENERIC_ESTIMATE_NOTE = 'This item cannot be ordered yet: it is an estimate only.';

/** The Add button's tooltip when a kind offers no product (and its registry entry has no wording). */
export const BUDGET_NOTHING_TO_ADD = 'Nothing can be added here yet.';

/** The totals card, when `totals.complete` is false. */
export const BUDGET_INCOMPLETE_TOTALS_NOTE =
  'These totals leave out the lines marked “No longer available” or “Price not available”.';

export const BUDGET_EMPTY_TITLE = 'No budgets yet';

export const BUDGET_EMPTY_BODY =
  'Estimate the monthly cost of GPU servers before you start them, with supplementary storage as an estimate.';

/** The "Other items" section: lines of a kind the catalog no longer offers (Remove only). */
export const BUDGET_OTHER_ITEMS_TITLE = 'Other items';

export const BUDGET_OTHER_ITEMS_NOTE =
  'These lines are of a kind that can no longer be added to a budget. They are not counted in the total; you can remove them.';

/** A line's product row is gone. */
export const BUDGET_REMOVED_PRODUCT = 'Removed product';

/** Status labels of a line that is not `ok`. */
export const BUDGET_STATUS_UNAVAILABLE = 'No longer available';
export const BUDGET_STATUS_PRICE_UNAVAILABLE = 'Price not available';

/** Line modal helpers when the stored product is not offered any more. */
export const BUDGET_PRODUCT_NOT_OFFERED = 'This product is no longer available — choose another one.';
export const BUDGET_PRODUCT_GONE = 'This product no longer exists — choose another one.';
